import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "participantItem"];

  static values = {
    participantIndex: { type: Number, default: 0 },
  };

  connect() {
    this.participantIndexValue = this.participantItemTargets.length;
    this.counter = this.participantItemTargets.length;
  }

  addParticipant(event) {
    event.preventDefault();

    const template = this.templateTarget;
    const newParticipant = template.content.cloneNode(true);

    const newIndex = this.counter;
    this.counter += 1;

    this.updateParticipantFields(newParticipant, newIndex);

    this.containerTarget.appendChild(newParticipant);

    const firstNameField = this.containerTarget.lastElementChild.querySelector(
      'input[name*="[first_name]"]'
    );
    if (firstNameField) {
      firstNameField.focus();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  removeParticipant(event) {
    const participantItem = event.target.closest(".participant-item");
    if (participantItem) {
      participantItem.remove();
    }
  }

  currentMaxIndex() {
    let max = -1;
    const fields = this.containerTarget.querySelectorAll(
      'input[name^="participants["], select[name^="participants["], textarea[name^="participants["]'
    );

    fields.forEach((el) => {
      const m = el.name.match(/^participants\[(\d+)\]/); // match numeric keys only
      if (m) {
        const n = parseInt(m[1], 10);
        if (!Number.isNaN(n) && n > max) max = n;
      }
    });

    return max;
  }

  // eslint-disable-next-line class-methods-use-this
  updateParticipantFields(participantElement, index) {
    const formFields = participantElement.querySelectorAll(
      "input, select, textarea"
    );

    formFields.forEach((field) => {
      if (field.name) {
        field.setAttribute(
          "name",
          field.name.replaceAll("__INDEX__", String(index))
        );
      }

      if (field.id) {
        field.setAttribute(
          "id",
          field.id.replaceAll("__INDEX__", String(index))
        );
      }
    });

    const labels = participantElement.querySelectorAll("label");
    labels.forEach((label) => {
      if (label.htmlFor) {
        label.setAttribute(
          "for",
          label.htmlFor.replaceAll("__INDEX__", String(index))
        );
      }
    });

    const participantLabel = participantElement.querySelector(
      "h3[data-participant-label]"
    );
    if (participantLabel) {
      participantLabel.textContent = participantLabel.textContent.replace(
        "__INDEX__",
        String(index + 1)
      );
    }
  }
}
